let V2Service = function ($cookieStore, $rootScope) {

    let redirectToV2 = function (roleId) {
        $rootScope.globals.currentUser.roleId = roleId;
        var stringCookie = 'globals=' + JSON.stringify($rootScope.globals) + '; path=/' + V2CONTEXT + '/;';
        // Delete V2 cookie by setting the expiry date in the past
        var d = new Date();
        d.setTime(d.getTime() - 1);
        var expires = 'expires=' + d.toUTCString() + ';';
        document.cookie = stringCookie + expires;

        // $cookieStore.put('globals', $rootScope.globals);
        // Update v2 cookie with updated token
        document.cookie = stringCookie;
        window.location = window.location.origin + '/' + V2CONTEXT + '/index.html';
      }

    return { redirectToV2 };
};

export default V2Service;



// WEBPACK FOOTER //
// ./client/app/common/services/v2.service.js